// src/config/config.ts
const getApiConfig = () => {
  // Primary source: Environment variables
  const envApiUrl = process.env.REACT_APP_API_URL;
  if (envApiUrl) {
    return envApiUrl;
  }

  // Fallback: Default configuration
  // This makes it easy to switch to a config file later
  return 'https://localhost:7084/api';
};

const getGoogleClientId = () => {
  const envClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  if (envClientId) {
    return envClientId;
  }
  return '388866422512-p43t9trhfptj8lm6smni461j9ao7vuao.apps.googleusercontent.com';
};

export const config = {
  apiUrl: getApiConfig(),
  googleClientId: getGoogleClientId(),
};
